var React = require('react');

function Ribbon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M181.687 461.612L0 350.174 214.781 0l752.393 461.483-.08.13H181.687z","fill":"#1b262c"}));
}

Ribbon.defaultProps = {"viewBox":"0 0 968 462","fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","fill":"#1b262c"};

module.exports = Ribbon;

Ribbon.default = Ribbon;
